import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GlobalConfigToast } from './configuration';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  options = GlobalConfigToast;

  constructor(private toastr: ToastrService) {}

  showSuccess(message: string, title: string = null): void {
    this.toastr.success(message, title, this.options);
  }

  showMessage(message: string, title: string = null): void {
    this.toastr.show(message, title, this.options);
  }

  showInfo(message: string, title: string = null): void {
    this.toastr.info(message, title, this.options);
  }

  showWarning(message: string, title: string = null): void {
    this.toastr.warning(message, title, this.options);
  }

  showError(message: string, title: string = null): void {
    this.toastr.error(message, title, this.options);
  }

  showLastLogin(message: string, title: string = null): void {
    this.toastr.success(message, title, {
      ...this.options,
      toastClass: 'ngx-toastr toast-login',
    });
  }
}
